import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


import PaymentNoticeScanView from '../payment-notice/payment-notice-scan-view.js'


class InvoiceView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;
		
		this.dataobject = null;

		this.quote = null;
		this.order = null;
		this.invoice = null;
		
		let title = '';
		let description = '';
		let amount = 0;
		let currency = {symbol: ''};
		let currentcard = null;

		
		this.state = {
				title,
				description,
				amount,
				currency,
				registration_text: 'loading...',
				message_text: 'loading...',
				sharelinkmessage: 'loading...',
				sharelink: 'loading...',
				currentcard,
				isQuoteOwner: false,
				isOrderOwner: false,
				isInvoiceOwner: false,
				vendoraddress: '',
				vendorname: '',
				vendoremail: ''
		}
	}

	
	// post render commit phase
	componentDidMount() {
		console.log('InvoiceView.componentDidMount called');
		let mvcmodule = this.getMvcModuleObject();
		let sessionuuid = this.props.rootsessionuuid;
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let registration_text = mvcmyquote.t('This invoice has been registered.');
		
		let message_text = mvcmyquote.t('Vendor details:');
	
		let sharelinkmessage = mvcmyquote.t('Send this link to the buyer to pay this invoice:');
		
		
		this.setState({registration_text, message_text, sharelinkmessage});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;
		
		if (app_nav_target && (app_nav_target.route == 'invoice') && (app_nav_target.reached == false)) {
			var params = app_nav_target.params;
			var dataobj = params.dataobject;

			if (dataobj && (dataobj.type === 'invoice') && (dataobj.treated !== true)) {
				this.dataobject = dataobj;

				let invoice = dataobj;
				this.invoice = dataobj;

				let txhash = params.txhash;
	
				let amount = invoice.amount;
				let currencyuuid = invoice.currencyuuid;

				// time
				let registration_text = mvcmyquote.t('This invoice has been registered on');

				registration_text += ' ' + mvcmodule.formatDate(invoice.blocktime, 'YYYY-mm-dd HH:MM:SS') + '.';


				// vendor details
				let vendorname_encrypted = invoice.ownername;
				let vendoremail_encrypted = invoice.owneremail;
				
				let vendoraddress = invoice.owner;
				let vendorname = mvcmodule.fitString(vendorname_encrypted, 12);
				let vendoremail = mvcmodule.fitString(vendoremail_encrypted, 12);
	
				let currency = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {
					console.log('error in InvoiceView.checkNavigationState: ' + err);
				});
	
				var sharelink =  await this.app.getShareLink(txhash, currency.uuid);

				// original order
				let order = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, invoice.order);
				this.order = order;

				// original quote
				let quote = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, order.quote);
				this.quote = quote;

				let title = quote.title;
				let description = quote.description;

				// look if a wallet is open
				let currentcard = null;
				let isQuoteOwner = false;
				let isOrderOwner = false;
				let isInvoiceOwner = false;

				let unlocked = await this.app.checkWalletUnlocked()
				.catch(err => {
				});

				if (unlocked) {
					let currentwallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
					
					// is it the quote owner and/or the order own
					currentcard = await this.app.openCurrencyCard(currencyuuid)
					.catch(err => {
						console.log('error in InvoiceCreateForm.onSubmit: ' + err);
					});

					if (currentcard) {
						let decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, invoice.owner);
						
						if (decryptcard) {
							isInvoiceOwner = true;

							vendorname = mvcmyquote.t('You');
							vendoremail = currentwallet.owneremail;					
						}

						decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, order.owner);
						if (decryptcard) {
							isOrderOwner = true;

							// we decrypt the vendor's details
							let vendor_rsa_publickey = invoice.owner_rsa_publickey;
	
							let vendorname_plain = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, vendor_rsa_publickey, vendorname_encrypted)
							.catch(err => {
								console.log('error in InvoiceCreateForm.onSubmit: ' + err);
							});
	
							let vendoremail_plain = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, vendor_rsa_publickey, vendoremail_encrypted)
							.catch(err => {
								console.log('error in InvoiceCreateForm.onSubmit: ' + err);
							});
							
							vendorname = (vendorname_plain ? vendorname_plain : vendorname);
							vendoremail = (vendoremail_plain ? vendoremail_plain  : vendoremail);					
	
						}

						decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, quote.owner);
						if (decryptcard) {
							isQuoteOwner = true;
						}
					}
				}
	
				this.setState({title, description, amount, currency, currentcard, registration_text, isQuoteOwner, isOrderOwner, isInvoiceOwner, sharelink, vendoraddress, vendorname, vendoremail});

				dataobj.viewed = true;
			}

			// mark target as reached
			app_nav_target.reached = true;		
		}
	}
	
	
	// user actions
	async onSubmit() {
		console.log('onSubmit pressed!');
		
		if (this.dataobject) {
			let params = {action: 'create', txhash: this.dataobject.txhash, currencyuuid: this.dataobject.currencyuuid, dataobject: this.dataobject};
			this.app.gotoRoute('paymentnotice', params);
		}
		else
			this.app.alert('Invoice parameters not found');
		
		return true;
	}

	async onShareLinkClick() {
		const {sharelink} = this.state;
		
		// create a textarea on the fly, then remove it to
		// be able to copy to clipboard
		var textArea = document.createElement("textarea");
		textArea.value = sharelink;

		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand("Copy");
		textArea.remove();

		this.app.alert("Share link has been copied to clipboard");
	}

	
	// rendering
	renderInvoiceView() {
		let { title, description, amount, currency, registration_text, message_text, sharelinkmessage, sharelink, 
			isQuoteOwner, isOrderOwner, isInvoiceOwner, vendoraddress, vendorname, vendoremail } = this.state;
		let iswalletlocked = this.props.iswalletlocked;
		
		return (
			<div className="Form">
				<FormGroup controlId="title">
				<FormLabel>Quote Title</FormLabel>
				<FormControl
					disabled
					autoFocus
					type="text"
					value={title}
					onChange={e => this.setState({title: e.target.value})}
				/>
				</FormGroup>

				<FormGroup controlId="VendorAddress">
					<FormLabel>Vendor Address {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
					<FormControl
						autoFocus
						type="text"
						value={vendoraddress}
						onChange={e => this.setState({vendoraddress: e.target.value})}
					/>
				</FormGroup>

				<FormGroup className="Proposal" controlId="proposal">
				<span className="ProposalCol">
				<FormLabel>Amount</FormLabel>
				<FormControl 
					disabled
					autoFocus
					type="text"
					value={amount}
					onChange={e => this.setState({amount: e.target.value})}
				/>
				</span>
				<span className="ProposalCol">
				<FormLabel>Currency</FormLabel>
				<InputGroup>
					<FormControl 
						disabled
						autoFocus
						type="text"
						value={currency.symbol}
						onChange={e => this.onChangeCurrency(e)}
					/>
				</InputGroup>
				</span>
				</FormGroup>

				<div className="TextBox">
				{registration_text}
				</div>
				
				<div className="TextBox">
				<div>{sharelinkmessage}</div>
					<div className="ShareBlock">
					<span className="ShareLink" onClick={this.onShareLinkClick.bind(this)}>{sharelink}</span>
					<span className="ShareIcon" onClick={this.onShareLinkClick.bind(this)}><FontAwesomeIcon icon={faCopy} /></span>
					</div>
				</div>

				{(isOrderOwner ?
				<Button onClick={this.onSubmit.bind(this)} type="submit">
					Send Payment Notice
				</Button> :
				(iswalletlocked ? <div className="Separator"><span>you are not logged in</span></div> : <hr></hr>)
				)}

				<div className="TextBox">
				{message_text}
				</div>

				<div className="TextBox">
				<div><span>Vendor Name: </span><span>{vendorname}</span></div>
				<div><span>Vendor Email: </span><span>{vendoremail}</span></div>
				</div>



				{(this.dataobject ?
				<div>
				<hr></hr>
				<div>
					<PaymentNoticeScanView app={this.app} invoice={this.dataobject} />
				</div>
				</div> :
				<></>
				)}
			</div>
		  );
	}

	render() {
		return (
			<div className="Container">
				<div className="Title">Invoice View</div>
				{ this.renderInvoiceView()}
			</div>
		  );
	}
	
}


// propTypes validation
InvoiceView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
	iswalletlocked: PropTypes.bool,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
		iswalletlocked: state.wallets.islocked,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {InvoiceView};
export default connect(mapStateToProps, mapDispatchToProps)(InvoiceView);

